export default __webpack_public_path__ + "static/media/0x874e178a2f3f3f9d34db862453cd756e7eab0381.4a26547f.webp";